import i18n from 'i18next';

export default function getLogoSource() {
    return '/images/connect1d-logo.svg';
}